export enum USER_ROLE {
  ADMIN = 'ADMIN',
  AGENT = 'AGENT',
  DPI = 'DPI',
  VISITOR = 'VISITOR',
}

export enum USER_STATUS {
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  PENDING = 'PENDING',
  REGISTERED = 'REGISTERED',
  SHELL = 'SHELL',
}

export enum USER_TYPE {
  PASSWORD_EXPIRED = 'PASSWORD_EXPIRED',
  SET_PASSWORD = 'SET_PASSWORS',
}

export type UserAddViewModel = {
  department: string;
  email: string;
  firstName: string;
  isActive: boolean;
  lastName: string;
  notify: boolean;
  phoneNumber: string;
  role: USER_ROLE;
  username: string;
};

export type UserGetListViewModel = {
  createdAt: string;
  createdBy: {};
  department: string;
  email: string;
  firstName: string;
  id: string;
  isActive: boolean;
  lastName: string;
  phoneNumber: string;
  role: USER_ROLE;
  status: USER_STATUS;
  username: string;
};

export type UserGetViewModel = {
  createdAt: string;
  createdBy: {};
  department: string;
  email: string;
  firstName: string;
  history: UserHistoryGetViewModel[];
  id: string;
  isActive: boolean;
  lastName: string;
  lastNotificationAt: string;
  passwordUpdatedAt: string;
  phoneNumber: string;
  role: USER_ROLE;
  status: USER_STATUS;
  username: string;
};

export type UserHistoryGetViewModel = {
  department: string;
  email: string;
  firstName: string;
  isActive: boolean;
  lastName: string;
  phoneNumber: string;
  role: USER_ROLE;
  status: USER_STATUS;
  updatedAt: string;
  updatedBy: UserGetViewModel;
};

export type UserModifyViewModel = {
  department: string;
  email: string;
  firstName: string;
  isActive: boolean;
  lastName: string;
  phoneNumber: string;
  role: USER_ROLE;
};
